import React, { memo } from 'react';
import { Accordion as ChakraAccordion, AccordionItem, AccordionProps } from '@chakra-ui/accordion';

interface IProps extends AccordionProps {}

const AccordionComponent: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <ChakraAccordion allowMultiple {...props} border="none">
      <AccordionItem border="none">{children}</AccordionItem>
    </ChakraAccordion>
  );
};

export const Accordion = memo(AccordionComponent);
